import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { INVOICING_SETTINGS_SECTION_MAX_WIDTH } from '../../constants/invoicingSettingsSectionMaxWidth'
import { INVOICING_SETTINGS_SIDE_NAV_WIDTH } from '../../constants/invoicingSettingsSideNavWidth'

export const InvoicingSettingsModalContentWrapper = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: ${INVOICING_SETTINGS_SIDE_NAV_WIDTH}px minmax(0, 1fr);
  width: 100%;
  min-height: 0;
  position: relative;
  overflow: hidden;
`

export const InvoicingSettingsModalMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
  min-height: 0;
  padding: ${Spacing.S16} ${Spacing.S32} ${Spacing.S24};
  overflow: hidden;
`

export const InvoicingSettingsModalColumnsWrapper = styled.div`
  display: grid;
  flex: 1;
  gap: ${Spacing.S24};
  grid-template-columns: repeat(2, minmax(0, ${INVOICING_SETTINGS_SECTION_MAX_WIDTH}px));
  justify-content: center;
  min-height: 0;
  overflow: hidden;
`

export const InvoicingSettingsFormWrapper = styled.div`
  min-height: 0;
  padding-right: ${Spacing.S16};
  overflow-y: auto;

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      background-color: ${Color.Grey150};
    }
  }
`

export const InvoicingSettingsModalFooterActionsWrapper = styled.div`
  align-self: center;
  width: 100%;
  max-width: calc(2 * ${INVOICING_SETTINGS_SECTION_MAX_WIDTH}px + ${Spacing.S24});
`
